import * as React from "react";
import HouseholdCard from "../../../../components/UI/HouseholdCard";
import { formatPhone } from "../../../../utilities/format";
import {
  Email,
  Group,
  Person,
  Phone,
  PhoneIphone,
  BusinessCenter,
  Payment,
} from "@material-ui/icons";

function HouseholdDetails({ householdDetails, adminView, custodianMap }) {
  const primaryClient = householdDetails.Clients[0];
  const secondaryClient = householdDetails.Clients[1];
  const householdBdRepCode =
    householdDetails.RepCode && householdDetails.RepCode.bdRepCode;

  const custodialRepCode =
    householdDetails.RepCode && householdDetails.RepCode.custodialRepCode;

  return (
    <HouseholdCard
      fields={[
        [<Person />, primaryClient.fullName],
        [<Group />, secondaryClient && secondaryClient.fullName],
        [
          <Email />,
          <a
            href={`mailto: ${primaryClient.profile.email}`}
            target={"_blank"}
            rel="noopener"
          >
            {primaryClient.profile.email}
          </a>,
        ],
        [<PhoneIphone />, formatPhone(primaryClient.profile.phone)],
        [...(!primaryClient.profile.phone && [<Phone />, formatPhone(primaryClient.profile.homePhone)]
        )],
        // [<AccountBalance />, custodian],
        [<BusinessCenter />, householdBdRepCode],
        [<Payment />, custodialRepCode],
      ]}
      householdDetails={householdDetails}
      adminView={adminView}
    />
  );
}

export default HouseholdDetails;



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/HouseholdDetails/index.jsx